{
  "dss": {
    "footer": {
      "legalEntity": "STIHL Gesellschaft m. b. H. \n Fachmarktstraße 7, 2334 Vösendorf"
    },
    "link": {
      "contact": "https://support.stihl.com/de-AT/websso-contact/",
      "faq": "https://support.stihl.com/de-AT/externalkbsearchwebsso/"
    },
    "page": {
      "postPwSet": {
        "link_name": "Weiter zum Login",
        "link_url": "/user/ui/"
      }
    }
  }
}
